// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Note node: a title and simple markdown on a color of its own. The note's
   color, ink and link color are set on the element (utils/noteColors); fonts,
   radii and the form's controls use the tokens in styles/curioTokens.css. */

.jfLFuFaDL0gzWAQufW78 {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  padding: 10px 12px;
  overflow-y: auto;
  border-radius: var(--curio-radius-sm);
  font-family: var(--curio-font-family);
  font-size: 13px;
  line-height: 1.45;
  overflow-wrap: anywhere;
  user-select: text;
  cursor: text;
}

.gSfhpgREIa0SIVI7hisL {
  margin: 0 0 6px;
  padding-right: 44px;
  font-size: 14px;
  font-weight: 700;
}

.jg8ipVdxcyHeQ3qkFtmQ > :first-child {
  margin-top: 0;
}

.jg8ipVdxcyHeQ3qkFtmQ p,
.jg8ipVdxcyHeQ3qkFtmQ ul,
.jg8ipVdxcyHeQ3qkFtmQ ol,
.jg8ipVdxcyHeQ3qkFtmQ pre,
.jg8ipVdxcyHeQ3qkFtmQ blockquote {
  margin: 4px 0;
}

.jg8ipVdxcyHeQ3qkFtmQ ul,
.jg8ipVdxcyHeQ3qkFtmQ ol {
  padding-left: 18px;
}

.jg8ipVdxcyHeQ3qkFtmQ h1,
.jg8ipVdxcyHeQ3qkFtmQ h2,
.jg8ipVdxcyHeQ3qkFtmQ h3,
.jg8ipVdxcyHeQ3qkFtmQ h4,
.jg8ipVdxcyHeQ3qkFtmQ h5,
.jg8ipVdxcyHeQ3qkFtmQ h6 {
  margin: 8px 0 2px;
  font-size: 13px;
  font-weight: 700;
}

.jg8ipVdxcyHeQ3qkFtmQ h1 {
  font-size: 15px;
}

.jg8ipVdxcyHeQ3qkFtmQ h2 {
  font-size: 14px;
}

.jg8ipVdxcyHeQ3qkFtmQ a {
  color: var(--note-link);
  text-decoration: underline;
}

.jg8ipVdxcyHeQ3qkFtmQ code {
  font-family: var(--curio-font-mono);
  font-size: 12px;
}

.jg8ipVdxcyHeQ3qkFtmQ pre {
  overflow-x: auto;
  white-space: pre-wrap;
}

.jg8ipVdxcyHeQ3qkFtmQ blockquote {
  padding-left: 8px;
  border-left: 2px solid currentColor;
}

.eXbjczUMA0c1w_PR1nT9 {
  margin: 0;
  opacity: 0.75;
}

.d3wuhIKS3DD07cVP873R {
  position: absolute;
  top: 6px;
  right: 6px;
  height: 22px;
  padding: 0 8px;
  border: 1px solid currentColor;
  border-radius: var(--curio-radius-sm);
  background: transparent;
  color: inherit;
  font-family: inherit;
  font-size: var(--curio-font-size-xs);
  font-weight: 500;
  cursor: pointer;
  opacity: 0.75;
}

.d3wuhIKS3DD07cVP873R:hover,
.d3wuhIKS3DD07cVP873R:focus-visible {
  opacity: 1;
}

.JmY0KGLzqrndlHXLl_TQ {
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-sizing: border-box;
  height: 100%;
  padding: 8px 10px;
  overflow-y: auto;
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-xs);
  color: var(--curio-text-primary);
  background: var(--curio-card-bg);
}

.SDEbtj54sn6FVk84gsf2 {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  color: var(--curio-text-secondary);
}

.SDEbtj54sn6FVk84gsf2 input,
.SDEbtj54sn6FVk84gsf2 textarea {
  box-sizing: border-box;
  width: 100%;
  padding: 4px 6px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-sm);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font-family: inherit;
  font-size: var(--curio-font-size-xs);
}

.SDEbtj54sn6FVk84gsf2 textarea {
  flex: 1;
  min-height: 72px;
  resize: vertical;
  font-family: var(--curio-font-mono);
}

.SDEbtj54sn6FVk84gsf2 input:focus,
.SDEbtj54sn6FVk84gsf2 textarea:focus {
  outline: 2px solid var(--curio-role-update-fg);
  outline-offset: -1px;
}

.ZAbIYbE6Gq7hDzB0cl82 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.rBw8RRrHyiGpbyCvMhrC {
  margin-right: 2px;
  color: var(--curio-text-secondary);
}

.MYo2Xoa3DifE6Hy1JR9g {
  width: 18px;
  height: 18px;
  padding: 0;
  border: 1px solid var(--curio-border-strong);
  border-radius: 50%;
  cursor: pointer;
}

.MYo2Xoa3DifE6Hy1JR9g[aria-checked="true"] {
  outline: 2px solid var(--curio-role-update-fg);
  outline-offset: 1px;
}

.VzS83NDHrCVpI7Gdy7No {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.GIQgtASFCdKmPIuOyuL0 {
  height: 22px;
  padding: 0 10px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-sm);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font-family: inherit;
  font-size: var(--curio-font-size-xs);
  font-weight: 500;
  cursor: pointer;
}

.GIQgtASFCdKmPIuOyuL0:hover {
  border-color: var(--curio-text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/notes/Note.module.css"],"names":[],"mappings":"AAAA;;4EAE4E;;AAE5E;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;;;EAME,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,qCAAqC;EACrC,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,oCAAoC;EACpC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,kCAAkC;AACpC;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;EAEE,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":["/* The Note node: a title and simple markdown on a color of its own. The note's\n   color, ink and link color are set on the element (utils/noteColors); fonts,\n   radii and the form's controls use the tokens in styles/curioTokens.css. */\n\n.note {\n  position: relative;\n  box-sizing: border-box;\n  height: 100%;\n  padding: 10px 12px;\n  overflow-y: auto;\n  border-radius: var(--curio-radius-sm);\n  font-family: var(--curio-font-family);\n  font-size: 13px;\n  line-height: 1.45;\n  overflow-wrap: anywhere;\n  user-select: text;\n  cursor: text;\n}\n\n.title {\n  margin: 0 0 6px;\n  padding-right: 44px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.body > :first-child {\n  margin-top: 0;\n}\n\n.body p,\n.body ul,\n.body ol,\n.body pre,\n.body blockquote {\n  margin: 4px 0;\n}\n\n.body ul,\n.body ol {\n  padding-left: 18px;\n}\n\n.body h1,\n.body h2,\n.body h3,\n.body h4,\n.body h5,\n.body h6 {\n  margin: 8px 0 2px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.body h1 {\n  font-size: 15px;\n}\n\n.body h2 {\n  font-size: 14px;\n}\n\n.body a {\n  color: var(--note-link);\n  text-decoration: underline;\n}\n\n.body code {\n  font-family: var(--curio-font-mono);\n  font-size: 12px;\n}\n\n.body pre {\n  overflow-x: auto;\n  white-space: pre-wrap;\n}\n\n.body blockquote {\n  padding-left: 8px;\n  border-left: 2px solid currentColor;\n}\n\n.empty {\n  margin: 0;\n  opacity: 0.75;\n}\n\n.edit {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid currentColor;\n  border-radius: var(--curio-radius-sm);\n  background: transparent;\n  color: inherit;\n  font-family: inherit;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 500;\n  cursor: pointer;\n  opacity: 0.75;\n}\n\n.edit:hover,\n.edit:focus-visible {\n  opacity: 1;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  box-sizing: border-box;\n  height: 100%;\n  padding: 8px 10px;\n  overflow-y: auto;\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-xs);\n  color: var(--curio-text-primary);\n  background: var(--curio-card-bg);\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin: 0;\n  color: var(--curio-text-secondary);\n}\n\n.field input,\n.field textarea {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 4px 6px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font-family: inherit;\n  font-size: var(--curio-font-size-xs);\n}\n\n.field textarea {\n  flex: 1;\n  min-height: 72px;\n  resize: vertical;\n  font-family: var(--curio-font-mono);\n}\n\n.field input:focus,\n.field textarea:focus {\n  outline: 2px solid var(--curio-role-update-fg);\n  outline-offset: -1px;\n}\n\n.colors {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.colorsLabel {\n  margin-right: 2px;\n  color: var(--curio-text-secondary);\n}\n\n.swatch {\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.swatch[aria-checked=\"true\"] {\n  outline: 2px solid var(--curio-role-update-fg);\n  outline-offset: 1px;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.button {\n  height: 22px;\n  padding: 0 10px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font-family: inherit;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.button:hover {\n  border-color: var(--curio-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"note": `jfLFuFaDL0gzWAQufW78`,
	"title": `gSfhpgREIa0SIVI7hisL`,
	"body": `jg8ipVdxcyHeQ3qkFtmQ`,
	"empty": `eXbjczUMA0c1w_PR1nT9`,
	"edit": `d3wuhIKS3DD07cVP873R`,
	"form": `JmY0KGLzqrndlHXLl_TQ`,
	"field": `SDEbtj54sn6FVk84gsf2`,
	"colors": `ZAbIYbE6Gq7hDzB0cl82`,
	"colorsLabel": `rBw8RRrHyiGpbyCvMhrC`,
	"swatch": `MYo2Xoa3DifE6Hy1JR9g`,
	"actions": `VzS83NDHrCVpI7Gdy7No`,
	"button": `GIQgtASFCdKmPIuOyuL0`
};
export default ___CSS_LOADER_EXPORT___;
